import { Component, Input } from '@angular/core';
import { TranslationService } from '../../../woo_services.module/TranslationService';
import { CreativeStatus } from '../../../woo_services.module/shared-types';

@Component({
  selector: 'creative-status-label',
  template: `
    <span
      *ngIf="status === CreativeStatus.Unknown"
      class="icon-question-mark-outline text--cta icon__semi-medium"
    ></span>
    <span *ngIf="status === CreativeStatus.NotReady" class="icon-waiting-outline text--cta icon__semi-medium"></span>
    <span
      *ngIf="status === CreativeStatus.CapeIoFileNotFound"
      class="icon-heads-up-outline text--danger icon__semi-medium"
    ></span>
    <span *ngIf="status === CreativeStatus.Ready" class="icon-check text--success icon__semi-medium"></span>
    {{ convertCreativeStatus(status) }}
  `,
  standalone: false,
})
export class CreativeStatusLabel {
  readonly CreativeStatus = CreativeStatus;
  readonly convertCreativeStatus = this.translationService.convertCreativeStatus;
  @Input() status: CreativeStatus;
  constructor(private translationService: TranslationService) {}
}
